"use client";

import CookieConsent from "react-cookie-consent";

export default function CookieConsentBanner() {
  return (
    <CookieConsent
      disableStyles={true}
      location="bottom"
      buttonClasses="btn btn-primary"
      buttonWrapperClasses="text-center tw-mt-3"
      containerClasses="alert alert-warning col-lg-12"
      contentClasses="text-center"
      cookieName="accepted_cookies_consent"
      style={{
        zIndex: 99999,
        background: "white"
      }}
      expires={150}
    >
      This website require cookies to function.{" "}
    </CookieConsent>
  );
}
